export const DISTRIBUTION_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        backgroundColor: '#F9FAFB',
    },
    colors:['#AD509E'],
    title: {
        text: null,
    },
    subtitle: {
        text: null,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    xAxis: {
        type: 'category',
        title: {
            text: null,
        },
        lineColor: 'transparent',
    },
    yAxis: {
        labels: {
            enabled: false,
        },
        title: {
            text: null,
        },
        gridLineWidth: 0,
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: true,
                x: 1,
            },
        },
        series: {
            label: {
                enabled: false,
            },
            states: {
                hover: {
                    enabled: false,
                },
            },
            borderRadius: 5,
            pointWidth: 8,
            groupPadding: 0,
            pointPadding: 0,
        },
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    series: [
        {
            name: null,
            data: [
                ['VA 21.9%', 99600],
                ['IN 14.6%', 68400],
                ['WA 13.1%', 59578],
                ['AL 11.7%', 53210],
                ['RI 11.6%', 52756],
                ['ME 7.4%', 33654],
                ['OR 6.2%', 28197],
                ['CA 5.7%', 25923],
                ['AK 5.2%', 23649],
                ['GA 4.2%', 19101],
                ['NV 2.2%', 10005],
                ['FL 1.4%', 6367],
                ['PA 0.3%', 1364],
            ],
        },
    ],
};

export const CHART_SERIES = [
    {
        name: 'Population',
        data: [
            {
                x: 'VA 21.9%',
                y: 99600,
            },
            {
                x: 'IN 14.6%',
                y: 68400,
            },
            {
                x: 'WA 13.1%',
                y: 59578,
            },
            {
                x: 'AL 11.7%',
                y: 53210,
            },
            {
                x: 'RI 11.6%',
                y: 52756,
            },
            {
                x: 'ME 7.4%',
                y: 33654,
            },
            {
                x: 'OR 6.2%',
                y: 28197,
            },
            {
                x: 'CA 5.7%',
                y: 25923,
            },
            {
                x: 'AK 5.2%',
                y: 23649,
            },
            {
                x: 'GA 4.2%',
                y: 19101,
            },
            {
                x: 'NV 2.2%',
                y: 10005,
            },
            {
                x: 'FL 1.4%',
                y: 6367,
            },
            {
                x: 'PA 0.3%',
                y: 1364,
            },
        ],
        color: '#2E90FA',
    },
];

export const CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: {
            show: false,
        },
        animations: {
            enabled: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: true,
            borderRadius: 4,
            // barWidth:'70%',
            columnWidth: '45%',
            dataLabels: {
                position: 'top',
            },
        },
    },
    dataLabels: {
        enabled: true,
        style: {
            colors: ['#101828'],
        },
        formatter: function (val, opt) {
            return val.toLocaleString('en-US');
        },
        offsetX: 40,
    },
    legend: {
        show: false,
    },
    grid: {
        show: false,
    },
    xaxis: {
        labels: {
            show: false,
        },
        axisBorder: {
            show: false,
        },
    },
};

export const USA_CHART_OPTIONS = {
    title: {
        text: null,
    },
    chart: {
        backgroundColor: 'transparent',
        type: 'map',
        map: null,
    },
    mapNavigation: {
        enabled: false,
        enableButtons: false,
    },
    navigation: {
        buttonOptions: {
            enabled: false,
        },
    },
    credits: {
        enabled: false,
    },
    colorAxis: {
        min: 1,
        type: "logarithmic",
        minColor: "#FAEDF9",
        maxColor: "#8C3F7D",
        stops: [
            [0, "#FAEDF9"],
            [0.67, "#DB97D2"],
            [1, "#8C3F7D"],
        ],
    },
    tooltip: {
        formatter: function () {
            return '<b>' + this.point.name + '</b><br/>' + this.point.value;
        },
    },
    legend: {
        enabled: true,
        align: 'right',
        horizontalAlign: 'bottom',
        layout: 'horizontal',
        borderWidth: 0,
        margin: 0,
        x: -50,
        y: 0,
    },
    series: [
        {
            name: 'us map',
            dataLabels: {
                enabled: true,
                color: '#FFFFFF',
                format: '{point.postal-code}',
                // align: 'center',
                shadow: false,
                backgroundColor: 'transparent',
                zIndex: 6,
                style: {
                    textTransform: 'uppercase',
                    fontWeight: 'normal', 
                    fontStyle: 'normal', 
                    textOutline: 'none', 
                },
            },
            cursor: 'pointer',
            joinBy: 'postal-code',
        },
    ],
};
